import React from "react";
import CreateAccount from "../components/CreateAccount/";

const NewAccount = () => {
  return <CreateAccount />;
};

export default NewAccount;
